import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestSigned(props) {
    const { timestamp } = props;
    return (<ActivityEntry appearance="success" icon={getIcon('success')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Esigning activity - The eSigning request is signed by all parties">
            The eSigning request is signed by all parties
          </Trans>
        </ActivityEntryText>}/>);
}
